import RecommendationChip from "@app/analytics/components/RecommendationChip";
import type { Recommendation } from "@app/analytics/types";
import * as RecommendationUtils from "@app/analytics/utils/recommendationUtils";

const RecommendationActionIcon = ({
  recommendation,
}: {
  recommendation: Recommendation;
}) => {
  const {
    icon: Icon,
    backgroundColor,
    color,
  } = RecommendationUtils.getRecommendationActionIcon(recommendation);

  return (
    <RecommendationChip
      startIcon={<Icon sx={{ height: "12px", width: "12px" }} />}
      backgroundColor={backgroundColor}
      fontColor={color}
      sx={{ padding: "4px", flexShrink: 0 }}
    />
  );
};

export default RecommendationActionIcon;
